import { css } from 'emotion'

export const TeamStatWatcherStyles = css``
